import { useEffect } from 'react';

// Keep overlays inside the visible area when a phone keyboard opens.
export const useVisualViewport = () => {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const root = document.documentElement;
    let baselineHeight = window.innerHeight;
    let baselineWidth = window.innerWidth;
    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (Math.abs(window.innerWidth - baselineWidth) > 100) {
          baselineWidth = window.innerWidth;
          baselineHeight = window.innerHeight;
        }
        const active = document.activeElement;
        const editing = active?.matches('textarea, input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="button"]), [contenteditable="true"]');
        if (!editing) baselineHeight = Math.max(baselineHeight, window.innerHeight);
        // Pinch zoom is not a keyboard event; leave browser zoom behaviour alone.
        if (Math.abs(viewport.scale - 1) > 0.05) return;
        root.style.setProperty('--visual-viewport-height', `${viewport.height}px`);
        root.style.setProperty('--visual-viewport-top', `${viewport.offsetTop}px`);
        const keyboardOpen = editing && Math.max(baselineHeight, window.innerHeight) - viewport.height > 150;
        root.dataset.keyboardOpen = keyboardOpen ? 'true' : 'false';
        if (keyboardOpen) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    };
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    update();
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
      root.style.removeProperty('--visual-viewport-height');
      root.style.removeProperty('--visual-viewport-top');
      delete root.dataset.keyboardOpen;
    };
  }, []);
};